import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Divider,Grid, Typography } from '@mui/material';
import { Dropdown, DropdownButton } from 'react-bootstrap';
import { EGIconButton } from '../../../../MainComponents/Button/IconButton/IconButton';




const IndicatorsBoard = ({ indicators, onDelete, onMove, theme = "light" }) => {

  const [t] = useTranslation("dashboard");

  const items = Array.isArray(indicators)
    ? indicators
    : Object.values(indicators || {});

  return (
    <Box
      sx={{
        bgcolor: 'background.default',
        p: 3,
        borderRadius: 3,
        boxShadow: 3,
        mt: 4,
      }}
    >
      <Grid item xs={12}>
        <Typography variant="h3" sx={{ mb: 1 }}>
          {t("dashboard.indicators_title")}
        </Typography>
        <Divider sx={{ mb: 2 }} />
      </Grid>

      <Grid container spacing={3}>
        {items.map((item, index) => {
          const title = item.title || t("dashboard.untitled_indicator");
          const count =
            Array.isArray(item.data) && item.data.length > 0
              ? item.data[0].count ?? 0
              : 0;

          return (
            <Grid item xs={12} sm={6} md={4} key={item.id || index}>
              <Box
                sx={{
                  borderRadius: 2,
                  bgcolor: 'background.paper',
                  p: 3,
                  boxShadow: 2,
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 180,
                  position: 'relative',
                }}
              >
                {/* Flechas para mover arriba/abajo */}
                {onMove && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      left: 8,
                      zIndex: 1,
                      display: 'flex',
                      gap: 0.5,
                    }}
                  >
                    <EGIconButton
                      iconSize={16}
                      className="graphic-option"
                      iconName="arrow_up_4"
                      disabled={index === 0}
                      onClick={() => onMove(item.id, "up")}
                      title={t("Graphics.move_up")}
                    />
                    <EGIconButton
                      iconSize={16}
                      className="graphic-option"
                      iconName="arrow_down"
                      disabled={index === items.length - 1}
                      onClick={() => onMove(item.id, "down")}
                      title={t("Graphics.move_down")}
                    />
                  </Box>
                )}

                {/* Botón flotante encima del contenedor */}
                {onDelete && (
                  <Box
                    sx={{
                      position: 'absolute',
                      top: 8,
                      right: 8,
                      zIndex: 2,
                    }}
                  >
                    <DropdownButton
                      key="end"
                      id={`dropdown-button-drop-end-${item.id}`}
                      drop="end"
                      title={
                        <span style={{ fontSize: '10px', color: '#555' }}>
                          ooo
                        </span>
                      }
                      variant="link"
                      style={{
                        padding: 0,
                        margin: 0,
                        border: 'none',
                        background: 'transparent',
                        boxShadow: 'none',
                        minWidth: 'auto',
                      }}
                      className="dropdown-no-style"
                    >
                      <Dropdown.Item eventKey="1" onClick={() => onDelete(item.id)}>
                        {t("Graphics.delete") ?? t("dashboard.delete_indicator")}
                      </Dropdown.Item>
                    </DropdownButton>
                  </Box>
                )}

                <Typography variant="subtitle1" sx={{ mb: 2, textAlign: 'center' }}>
                  {title}
                </Typography>

                <Box
                  sx={{
                    width: 80,
                    height: 80,
                    borderRadius: '50%',
                    bgcolor: 'primary.main',
                    color: 'primary.contrastText',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 24,
                    fontWeight: 'bold',
                  }}
                >
                  {count}
                </Box>
              </Box>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default IndicatorsBoard;